import {
  Bookmark,
  FolderKanban,
  Hammer,
  LayoutDashboard,
  LayoutList,
  Plus,
  Workflow,
  Calendar,
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import Account from '../navbar/components/Account';
import { useContext, useState } from 'react';
import { UserContext } from '../../context/user/UserContext';
import { ChatContext } from '../../context/chat/ChatContext';
import { FaRegCompass } from 'react-icons/fa';
import { BiMessageRoundedDetail } from 'react-icons/bi';
import { UserDetailContext } from '../../context/userDetails/UserDetailContext';

export default function MobileBottomBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedIn, user, loading, handleLogout } =
    useContext(UserContext);
  const { userDetail } = useContext(UserDetailContext);
  const { unreadMsgCount } = useContext(ChatContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-10 bg-white/90 backdrop-blur border-t border-gray-200 pb-safe">
      <div className="relative h-14">
        {/* Floating Center Button */}
        <button
          onClick={() => navigate('/messages')}
          className="
      absolute left-1/2 -translate-x-1/2 -top-5
      z-10
      flex items-center justify-center
      w-12 h-12
      rounded-full
      bg-black text-white
      shadow-lg
      active:scale-95
    "
          aria-label="Messages"
        >
          <BiMessageRoundedDetail size={22} />
          {unreadMsgCount > 0 && (
            <span className="absolute -top-1 -right-1 bg-rose-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[20px] h-[20px] flex items-center justify-center border-2 border-white shadow-sm">
              {unreadMsgCount > 99 ? '99+' : unreadMsgCount}
            </span>
          )}
        </button>

        {/* Bottom Bar */}
        <div className="grid grid-cols-5 h-full items-center px-2">
          {/* Feed */}
          <BottomBarButton
            active={isActive('/feed')}
            onClick={() => navigate('/feed')}
            label="Feed"
          >
            <FaRegCompass size={26} />
          </BottomBarButton>

          {/* Saved */}
          {loggedIn && user?.active_role === 'user' && (
            <BottomBarButton
              active={isActive('/user/dashboard')}
              onClick={() => navigate('/user/dashboard')}
              label="Dashboard"
            >
              <LayoutDashboard size={26} />
            </BottomBarButton>
          )}
          {loggedIn && user?.active_role === 'artisan' && (
            <BottomBarButton
              active={isActive('/artisan/dashboard')}
              onClick={() => navigate('/artisan/dashboard')}
              label="Dashboard"
            >
              <LayoutDashboard size={26} />
            </BottomBarButton>
          )}
          {/* Empty center slot (IMPORTANT) */}
          <div />

          {/* Bookings */}
          {loggedIn && user?.active_role === 'user' && (
            <BottomBarButton
              active={isActive('/user/my-bookings')}
              onClick={() => navigate('/user/my-bookings')}
              label="Bookings"
            >
              <Calendar size={26} />
            </BottomBarButton>
          )}
          {loggedIn && user?.active_role === 'artisan' && (
            <BottomBarButton
              active={isActive('/artisan/project-hub')}
              onClick={() => navigate('/artisan/project-hub')}
              label="Project Hub"
            >
              <Workflow size={26} />
            </BottomBarButton>
          )}
          {/* Account */}
          <div className="lg:hidden flex justify-center">
            <Account
              setIsMenuOpen={setIsMenuOpen}
              loggedIn={loggedIn}
              user={user}
              loading={loading}
              userDetail={userDetail}
              handleLogout={handleLogout}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function BottomBarButton({ active, onClick, children, label }) {
  return (
    <button
      onClick={onClick}
      className="
        relative
        flex flex-col items-center justify-center
        w-full h-full
        transition active:scale-95
      "
      aria-label={label}
    >
      <div
        className={`
          transition-all duration-200
          ${active ? 'text-black scale-110' : 'text-gray-400'}
        `}
      >
        {children}
      </div>

      {/* Active Dot Indicator */}
      <span
        className={`
          absolute bottom-1
          h-1 w-1 rounded-full
          transition-opacity
          ${active ? 'bg-black opacity-100' : 'opacity-0'}
        `}
      />
    </button>
  );
}
